import { Entity, IEntity } from "./Entity";
import { IZCoreUserGroupMember } from "./ZCoreUserGroupMember";


export interface IZCoreUserGroup extends IEntity {
    CustomerID?: number;
    ZCoreUserGroupMembers?: IZCoreUserGroupMember[];
}

export class ZCoreUserGroup extends Entity implements IZCoreUserGroup {
    public CustomerID?: number = null;
}